import { render } from "./DemoThanks.vue?vue&type=template&id=405fe527&scoped=true"
import script from "./DemoThanks.vue?vue&type=script&lang=js"
export * from "./DemoThanks.vue?vue&type=script&lang=js"

import "./DemoThanks.vue?vue&type=style&index=0&id=405fe527&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-405fe527"]])

export default __exports__